import React from 'react';
import './WindowControls.css';
import minimizeIcon from '../../assets/images/minimize.png';
import minimizeHoverIcon from '../../assets/images/minimize_hover.png';
import maximizeIcon from '../../assets/images/maximize.png';
import maximizeHoverIcon from '../../assets/images/maximize_hover.png';
import closeIcon from '../../assets/images/close.png';
import closeHoverIcon from '../../assets/images/close_hover.png';

// 检查是否在Electron环境中
const isElectron = typeof window !== 'undefined' && window.require && window.require('electron');

// 检查是否是 Windows 平台
const isWindows = isElectron && typeof process !== 'undefined' && process.platform === 'win32';

const WindowControls: React.FC = () => {
  // 只在 Windows 上的 Electron 环境中显示
  if (!isWindows) {
    return null;
  }

  const handleMinimize = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      const { ipcRenderer } = window.require('electron');
      ipcRenderer.send('window-minimize');
    } catch (error) {
      console.error('Failed to minimize window:', error);
    }
  };

  const handleMaximize = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      const { ipcRenderer } = window.require('electron');
      ipcRenderer.send('window-maximize');
    } catch (error) {
      console.error('Failed to maximize window:', error);
    }
  };

  const handleClose = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      const { ipcRenderer } = window.require('electron');
      ipcRenderer.send('window-close');
    } catch (error) {
      console.error('Failed to close window:', error);
    }
  };

  return (
    <div className="window-controls">
      <button 
        className="window-control-btn minimize-btn" 
        onClick={handleMinimize}
      >
        <img 
          src={minimizeIcon} 
          className="icon-default"
          alt="最小化"
        />
        <img 
          src={minimizeHoverIcon} 
          className="icon-hover"
          alt=""
        />
      </button>
      <button 
        className="window-control-btn maximize-btn" 
        onClick={handleMaximize}
      >
        <img 
          src={maximizeIcon} 
          className="icon-default"
          alt="最大化"
        />
        <img 
          src={maximizeHoverIcon} 
          className="icon-hover"
          alt=""
        />
      </button>
      <button 
        className="window-control-btn close-btn" 
        onClick={handleClose}
      >
        <img 
          src={closeIcon} 
          className="icon-default"
          alt="关闭"
        />
        <img 
          src={closeHoverIcon} 
          className="icon-hover"
          alt=""
        />
      </button>
    </div>
  );
};

export default WindowControls;

